import { configureStore, createSlice } from '@reduxjs/toolkit'
import userJudgeReducer, * as userJudge from './user/judge'
import lscache from 'lscache'

export const handlePopup = createSlice({
    name: 'popup',
    initialState: {
        display: null,
        message: '',
    },
    reducers: {
        setDisplay: (e, action) => {
            e.display = action.payload
        },
        setMessage: (e, action) => {
            e.message = action.payload
        }
    }
})

export const handleAccount = createSlice({
    name: 'account',
    initialState: {
        data: null,
    },
    reducers: {
        setData: (e, action) => {
            e.data = action.payload
        },
    }
})
const exhibitionInitialState = {
    // ---------- overview api
    overview: null, // overview
    groupProjects: null, // overview.group.project_info
    groupProject: null, // overview.group.project_info[0]
    individualProjects: null, // overview.individual.individual_projects
    individualProject: null,
    // ---------- individual projects available api
    individualAvailableProjects: null,
    // ---------- group stages api
    groupStages: null,
    // ---------- individual stages api
    individualStages: null,
    // ---------- fee config api
    feeConfig: null,
}
export const handleExhibition = createSlice({
    name: 'exhibition',
    initialState: exhibitionInitialState,
    reducers: {
        setOverview: (e, action) => {
            e.overview = action.payload
        },
        setGroupProjects: (e, action) => {
            e.groupProjects = action.payload
        },
        setGroupProject: (e, action) => {
            e.groupProject = action.payload
        },
        setGroupStages: (e, action) => {
            e.groupStages = action.payload
        },
        setIndividualProjects: (e, action) => {
            e.individualProjects = action.payload
        },
        setIndividualProject: (e, action) => {
            e.individualProject = action.payload
        },
        setIndividualStages: (e, action) => {
            e.individualStages = action.payload
        },
        setIndividualAvailableProjects: (e, action) => {
            e.individualAvailableProjects = action.payload
        },
        setFeeConfig: (e, action) => {
            e.feeConfig = action.payload
        },
        reset: (e) => {
            return exhibitionInitialState
        },
    }
})
export const handleGlobal = createSlice({
    name: 'global',
    initialState: {
        sentryErrorEventId: null,
        language: null,
        currentExhibitYear: null,
        currentCompeteYear: null,
        yearList: [],
        schoolList: null,
        color: Math.floor(Math.random()*(5)) + 1,
        messageTimeout: 5000,
        userDefaultUrl: '/user/exhibit',
        userInteraction: false
    },
    reducers: {
        setSentryErrorEventId: (e, action) => {
            e.sentryErrorEventId = action.payload
        },
        setLanguage: (e, action) => {
            lscache.set('language', action.payload)
            e.language = action.payload
        },
        setCurrentExhibitYear: (e, action) => {
            e.currentExhibitYear = action.payload
        },
        setCurrentCompeteYear: (e, action) => {
            e.currentCompeteYear = action.payload
        },
        setYearList: (e, action) => {
            e.yearList = action.payload
        },
        setSchoolList: (e, action) => {
            e.schoolList = action.payload
        },
        setUserInteraction: (e, action) => {
            e.userInteraction = action.payload
        }
    }
})
export const handleCMS = createSlice({
    name: 'CMS',
    initialState: {
        // homeBanner: null,
        infoBanner: null,
        homeNews: null,
        registries: {},
        about: null,
        exhibitDescription: null,
        competeDescription: null,
        competeJudges: null,
        downloadWinners: null,
        downloadProcedure: null,
        downloadHandbook: null,
        downloadMedal: null,
        newsDataFetch: false,
        newsAll: null,
        newsAnnouncement: null,
        newsMedia: null,
        newsColumn: null,
        newsLecture: null,
        newsActivity: null,
        sponsors: null,
        jobCategories: null,
        infoAbout: {
            zh_hant: null,
            en: null,
        },
        infoTransportation: {
            zh_hant: null,
            en: null,
        },
        infoEvents: {
            zh_hant: null,
            en: null,
        },
        infoTimetable: {
            zh_hant: null,
            en: null,
        },
        billboard: null,
    },
    reducers: {
        // setHomeBanner: (e, action) => {
        //     e.homeBanner = action.payload
        // },
        setInfoBanner:(e, action) => {
            e.infoBanner = action.payload
        },
        setHomeNews: (e, action) => {
            e.homeNews = action.payload
        },
        setRegistries: (e, action) => {
            e.registries = action.payload
        },
        setAbout: (e, action) => {
            e.about = action.payload
        },
        setExhibitDescription: (e, action) => {
            e.exhibitDescription = action.payload
        },
        setCompeteDescription: (e, action) => {
            e.competeDescription = action.payload
        },
        setCompeteJudges: (e, action) => {
            e.competeJudges = action.payload
        },
        setDownloadWinners: (e, action) => {
            e.downloadWinners = action.payload
        },
        setDownloadProcedure: (e, action) => {
            e.downloadProcedure = action.payload
        },
        setDownloadHandbook: (e, action) => {
            e.downloadHandbook = action.payload
        },
        setDownloadMedal: (e, action) => {
            e.downloadMedal = action.payload
        },
        setNewsDataFetch: (e, action) => {
            e.newsDataFetch = action.payload
        },
        setNewsAll: (e, action) => {
            e.newsAll = action.payload
        },
        setNewsAnnouncement: (e, action) => {
            e.newsAnnouncement = action.payload
        },
        setNewsMedia: (e, action) => {
            e.newsMedia = action.payload
        },
        setNewsColumn: (e, action) => {
            e.newsColumn = action.payload
        },
        setNewsLecture: (e, action) => {
            e.newsLecture = action.payload
        },
        setNewsActivity: (e, action) => {
            e.newsActivity = action.payload
        },
        setSponsors: (e, action) => {
            e.sponsors = action.payload
        },
        setJobCategories: (e, action) => {
            e.jobCategories = action.payload
        },
        setInfoAbout: (e, action) => {
            e.infoAbout[action.payload.language] = action.payload.data
        },
        setInfoTransportation: (e, action) => {
            e.infoTransportation[action.payload.language] = action.payload.data
        },
        setInfoEvents: (e, action) => {
            e.infoEvents[action.payload.language] = action.payload.data
        },
        setInfoTimetable: (e, action) => {
            e.infoTimetable[action.payload.language] = action.payload.data
        },
        setBillboard: (e, action) => {
            e.billboard = action.payload
        },
    }
})
export const handleHome = createSlice({
    name: 'home',
    initialState: {
        banners: null,
    },
    reducers: {
        setBanners: (e, action) => {
            e.banners = action.payload
        },
    }
})

const competeInitialState = {
    stages: null,
    data: null,
    submitted: null,
    draft: null,
    history: null,
    categories: null
}
export const handleCompete = createSlice({
    name: 'compete',
    initialState: competeInitialState,
    reducers: {
        setStages: (e, action) => {
            e.stages = action.payload
        },
        setData: (e, action) => {
            e.data = action.payload
        },
        setSubmitted: (e, action) => {
            e.submitted = action.payload
        },
        setDraft: (e, action) => {
            e.draft = action.payload
        },
        setHistory: (e, action) => {
            e.history = action.payload
        },
        setCategories: (e, action) => {
            e.categories = action.payload
        },
        reset: (e) => {
            return competeInitialState
        },

    }
})

export const store = configureStore({
    devTools: true,
    reducer: {
        popup: handlePopup.reducer,
        account: handleAccount.reducer,
        global: handleGlobal.reducer,
        exhibition: handleExhibition.reducer,
        compete: handleCompete.reducer,
        CMS: handleCMS.reducer,
        home: handleHome.reducer,
        userJudge: userJudgeReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(userJudge?.middlewares?.listenerMiddleware?.middleware),
})

export default store